import CartManager from './cart-manager'

//
// Cart
//
;(($) => {
    $(() => {
        let module = $('.cart, .quick-order-form, #quick_order_quantity')

        // Only continue if module is on page
        if (!module.length) return
        const removeItemButton = module.find('.cart-item-remove button')

        removeItemButton.click(function () {
            let itemKey = $(this).closest('.cart-item').attr('data-item-key')
            let itemQty = $(this).closest('.cart-item').attr('data-item-quantity')
            CartManager.removeFromCart(itemKey, itemQty)
        })

        let quantityInput = module.find("input[name='cart-item-qty']")
        let debounceTimer = null;

        quantityInput.on('input change', function () {
            const input = this;
            clearTimeout(debounceTimer);

            debounceTimer = setTimeout(function () {
                let itemKey = $(input).closest('.cart-item').data('item-key');
                CartManager.updateItemQuantity(itemKey, input.value);
            }, 600); // adjust delay (300–600ms)
        });

        let customerTypeRadio = $('input[name=customerType]:radio')
        customerTypeRadio.change(function () {
            showCustomerForm(this.value)
        })

        let businessForm = $('#businessFormWrapper')
        let privateForm = $('#privateFormWrapper')

        function showCustomerForm(type) {
            if (type === 'private') {
                businessForm.hide()
                privateForm.show()
            } else if (type === 'business') {
                businessForm.show()
                privateForm.hide()
            }
        }

        let form = $('.checkout-section form')
        form.on('submit', function (e) {
            e.preventDefault();

            /* Apply check to fix issue LISXGPIM-211 */
            $(this).find("button[type='submit']").attr("disabled", true);
            var oneTimeQuoteSubmit = $('#oneTimeQuoteSubmit');
            if (!oneTimeQuoteSubmit.val()) {
                var flagInput = $('<input>', {
                    type: 'hidden',
                    id: 'oneTimeQuoteSubmit',
                    name: 'oneTimeQuoteSubmit',
                    value: '1'
                });
                form.append(flagInput);
            } else {
                $('#oneTimeQuoteSubmit').val('');
            }

            if (typeof CartManager.resetCartCount === 'function') {
                CartManager.resetCartCount()
            }
        })

        // ===============================
        // Attribute toggle initial setup
        // ===============================
        module.find('.cart-item-name').each(function () {
            let $wrapper = $(this);
            let $attributes = $wrapper.find('.item-attributes .itemAttr');
            let $toggle = $wrapper.find('.toggle-attributes');
            let visibleCount = $toggle.attr('data-visibleCount');

            if ($attributes.length > visibleCount) {
                $attributes.slice(visibleCount).hide();
                $toggle.show();
            } else {
                $toggle.hide();
            }
        })

        // ===============================
        // Attribute toggle click
        // ===============================
        module.on('click', '.toggle-attributes', function (e) {
            e.preventDefault()

            let $toggle = $(this);
            let $wrapper = $toggle.closest('.cart-item-name');
            let $attributes = $wrapper.find('.item-attributes .itemAttr');
            let visibleCount = $toggle.attr('data-visibleCount');

            if ($toggle.attr('data-label') === 'showMore') {
                $attributes.show();
                $toggle.attr('data-label', 'showLess').text(window.globals.trans('cart.item.show_less'));
            } else {
                $attributes.slice(visibleCount).hide();
                $toggle.attr('data-label', 'showMore').text(window.globals.trans('cart.item.show_more'));
            }
        })


        const QTY_SELECTOR = '.input-quantity, .quantity';

        /* ================================
        * HELPERS
        * ================================ */

        function getOrStoreSeparator(input, val) {
            let sep = input.data('separator');

            if (!sep) {
                sep = String(val).includes(',') ? ',' : '.';
                input.data('separator', sep);
            }

            return sep;
        }

        function parseQty(val) {
            if (val == null) return NaN;
            const num = Number(String(val).replace(',', '.'));
            return isNaN(num) ? NaN : num;
        }

        function formatQty(val, precision, separator) {
            let str;

            if (precision === 0) {
                str = Math.round(val).toString();
            } else {
                str = val.toFixed(precision);

                // remove trailing zeros
                str = str.replace(/\.?0+$/, '');
            }

            // restore comma separator if needed
            if (separator === ',') {
                str = str.replace('.', ',');
            }

            return str;
        }

        function getLimits(input) {
            return {
                min: input.attr('min') !== undefined ? Number(input.attr('min')) : 0,
                max: input.attr('max') !== undefined ? Number(input.attr('max')) : Infinity
            };
        }

        function getStep(input) {
            const precision = parseInt(input.data('cs-unit-precision')) || 0;
            return precision > 0 ? Math.pow(10, -precision) : 1;
        }

        /* ================================
        * ALLOW ONLY NUMBERS / DOT / COMMA
        * ================================ */

        module.on('input', QTY_SELECTOR, function () {
            let val = this.value.replace(/[^0-9.,]/g, '');

            // allow only one separator
            const match = val.match(/[.,]/);
            if (match) {
                const sep = match[0];
                const parts = val.split(/[.,]/);
                val = parts[0] + sep + parts.slice(1).join('');
                $(this).data('separator', sep); 
            }

            this.value = val;
        });

        /* ================================
        * CORE QUANTITY CHANGE
        * ================================ */

        function changeQty(input, direction) {
            const precision = parseInt(input.data('cs-unit-precision')) || 0;
            const step = getStep(input);
            const limits = getLimits(input);

            const raw = input.val();
            const separator = getOrStoreSeparator(input, raw);

            let value = parseQty(raw);
            if (isNaN(value)) value = limits.min;

            value += direction * step;
            value = Math.min(limits.max, Math.max(limits.min, value));

            input
                .val(formatQty(value, precision, separator))
                .trigger('change');
        }

        /* ================================
        * NORMALIZE ON BLUR / CHANGE
        * ================================ */

        module.on('blur change', QTY_SELECTOR, function () {
            const input = $(this);
            const precision = parseInt(input.data('cs-unit-precision')) || 0;
            const limits = getLimits(input);

            const raw = this.value;
            const separator = getOrStoreSeparator(input, raw);

            let value = parseQty(raw);
            if (isNaN(value)) value = limits.min;

            value = Math.min(limits.max, Math.max(limits.min, value));
            this.value = formatQty(value, precision, separator);
        });

        /* ================================
        * HOLD + / -
        * ================================ */

        let holdInterval = null;

        module.on('mousedown touchstart', '.button-increase, .button-decrease', function (e) {
            e.preventDefault();

            const btn = $(this);
            const input = btn.siblings(QTY_SELECTOR);
            if (!input.length) return;

            const direction = btn.hasClass('button-increase') ? 1 : -1;

            changeQty(input, direction);

            holdInterval = setInterval(() => {
                changeQty(input, direction);
            }, 150);
        });

        $(document).on('mouseup touchend', () => {
            clearInterval(holdInterval);
            holdInterval = null;
        });

        /* ================================
        * KEYBOARD ↑ ↓
        * ================================ */

        module.on('keydown', QTY_SELECTOR, function (e) {
            if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown') return;

            e.preventDefault();
            changeQty($(this), e.key === 'ArrowUp' ? 1 : -1);
        });

        /* ================================
        * MOUSE WHEEL
        * ================================ */

        module.on('wheel', QTY_SELECTOR, function (e) {
            e.preventDefault();
            changeQty($(this), e.originalEvent.deltaY < 0 ? 1 : -1);
        });
    })
})(jQuery)
